import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { BtnBackComponent } from '../../components/buttons/btn-back/btn-back.component';
import { DlgChangePasswordComponent } from './dlg-change-password/dlg-change-password.component';

@Component({
  selector: 'app-profile-settings',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    BtnBackComponent,
  ],
  templateUrl: './profile-settings.component.html',
})
export class ProfileSettingsComponent implements OnInit {
  private dialog: MatDialog = inject(MatDialog);

  ngOnInit(): void {}

  openChangePasswordDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = ['!p-0', '!bg-transparent', '!shadow-none'];

    this.dialog.open(DlgChangePasswordComponent, dialogConfig);
  }
}
